import { useState, useEffect } from 'react';
import Modal from '../../helpers/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLifeRing } from '@fortawesome/free-solid-svg-icons';

const HUBSPOT_EMBED_SCRIPT_SRC = 'https://js.hsforms.net/forms/embed/8953044.js';
const HUBSPOT_PORTAL_ID = '8953044';
const HUBSPOT_FORM_ID = '62dbda2c-d255-46f5-b5d4-f348574e7e17';
const HUBSPOT_REGION = 'na1';

export const SupportForm = ({ defaultProject = '' }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        if (!isModalOpen) return;

        const existing = document.querySelector(
            `script[src="${HUBSPOT_EMBED_SCRIPT_SRC}"]`
        );
        if (existing) return;

        const script = document.createElement('script');
        script.src = HUBSPOT_EMBED_SCRIPT_SRC;
        script.defer = true;
        document.body.appendChild(script);
    }, [isModalOpen]);

    const supportForm = (
        <div data-mts-default-project={defaultProject || undefined}>
            <h2 className="modal-title">Support Request</h2>
            <div
                className="hs-form-frame"
                data-region={HUBSPOT_REGION}
                data-form-id={HUBSPOT_FORM_ID}
                data-portal-id={HUBSPOT_PORTAL_ID}
            />
        </div>
    );

    return (
        <div>
            <button
                className="btn btn-secondary"
                onClick={() => setIsModalOpen(true)}
            >
                <FontAwesomeIcon icon={faLifeRing} /> Get Help with Your Project
            </button>

            {isModalOpen && (
                <Modal
                    form={supportForm}
                    setIsModalOpen={setIsModalOpen}
                    isWide={true}
                />
            )}
        </div>
    );
};
